import Validate from './validate.js';
import { UserAgent } from './index';

function Formatter() {
  // do nothing
}

Formatter.commonMaskChar = '*';

/**
 * 无效值显示：-
 * @param {*} text
 * @returns
 */
Formatter.hyphen = function (text) {
  if (Validate.isEmpty(text)) {
    return '-';
  } else {
    return text;
  }
};

/**
 * 金额格式化
 * @param {*} text
 * @returns
 */
Formatter.money = function (text) {
  text = '' + text;
  var h = text.split('.');
  h[0] = h[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (h[1]) {
    h[1] = (h[1] + '00').slice(0, 2);
  }

  h = h.join('.');
  return h;
};

const ChineseMoneyOp = {
  1: '一',
  2: '二',
  3: '三',
  4: '四',
  5: '五',
  6: '六',
  7: '七',
  8: '八',
  9: '九'
};
/**
 * 转汉化金额
 * @param {Money} text Validate.isMoney
 */
Formatter.chineseMoney = function (text) {
  text = '' + Number(text);
  var h = text.split('.');
  var c1 = ['亿', '万', '元'];
  var c2 = ['千', '百', '十', ''];
  var c3 = ['角', '分'];
  h[0] = h[0]
    .replace(/\B(?=(\d{4})+(?!\d))/g, ',')
    .split(',')
    .slice(-3); // 最多12位整数
  var c = c1.slice();
  h[0] = h[0]
    .map((m) => {
      var c = c2.slice();
      m = m
        .split('')
        .reverse()
        .map((each) => {
          if (ChineseMoneyOp[each]) {
            return `${ChineseMoneyOp[each]}${c.pop()}`;
          } else {
            c.pop();
            return '零';
          }
        })
        .reverse()
        .join('')
        .replace(/[零]{2,4}/g, '零')
        .replace(/零$/, '');
      return m;
    })
    .reverse()
    .map((each) => `${each}${c.pop()}`)
    .reverse()
    .join('');
  if (h[1]) {
    c = c3.slice();
    h[1] = h[1]
      .split('')
      .map((m) => `${ChineseMoneyOp[m] || '零'}${c.shift()}`)
      .join('');
  }
  return h
    .join('')
    .replace(/^一十/, '十')
    .replace(/^元(.+)/, '$1');
};

/**
 * 转大写汉化金额
 * @param {Money} text Validate.isMoney
 */
Formatter.moneyToCN = function (num) {
  if (!num || isNaN(num)) {
    return '';
  }
  // Constants:
  const MAXIMUM_NUMBER = 99999999999.99;
  const CN_ZERO = '零';
  const CN_ONE = '壹';
  const CN_TWO = '贰';
  const CN_THREE = '叁';
  const CN_FOUR = '肆';
  const CN_FIVE = '伍';
  const CN_SIX = '陆';
  const CN_SEVEN = '柒';
  const CN_EIGHT = '捌';
  const CN_NINE = '玖';
  const CN_TEN = '拾';
  const CN_HUNDRED = '佰';
  const CN_THOUSAND = '仟';
  const CN_TEN_THOUSAND = '万';
  const CN_HUNDRED_MILLION = '亿';
  const CN_DOLLAR = '元';
  const CN_TEN_CENT = '角';
  const CN_CENT = '分';
  const CN_INTEGER = '整';

  let zeroCount;
  let i;
  let p;
  let d;
  let quotient;
  let modulus;
  let currencyDigits = num;
  // Validate input string:
  currencyDigits = currencyDigits.toString();
  if (currencyDigits === '') {
    return '';
  }
  currencyDigits = currencyDigits.replace(/,/g, '');
  currencyDigits = currencyDigits.replace(/^0+/, '');
  if (Number(currencyDigits) > MAXIMUM_NUMBER) {
    return '';
  }

  const parts = currencyDigits.split('.');
  let [integral, decimal = ''] = parts;
  if (parts.length > 1) {
    decimal = decimal.substr(0, 2);
  }
  const digits = [
    CN_ZERO,
    CN_ONE,
    CN_TWO,
    CN_THREE,
    CN_FOUR,
    CN_FIVE,
    CN_SIX,
    CN_SEVEN,
    CN_EIGHT,
    CN_NINE
  ];
  const radices = ['', CN_TEN, CN_HUNDRED, CN_THOUSAND];
  const bigRadices = ['', CN_TEN_THOUSAND, CN_HUNDRED_MILLION];
  const decimals = [CN_TEN_CENT, CN_CENT];

  let outputCharacters = '';
  if (Number(integral) > 0) {
    zeroCount = 0;
    for (i = 0; i < integral.length; i++) {
      p = integral.length - i - 1;
      d = integral.substr(i, 1);
      quotient = p / 4;
      modulus = p % 4;
      if (d === '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          outputCharacters += digits[0];
        }
        zeroCount = 0;
        outputCharacters += digits[Number(d)] + radices[modulus];
      }
      if (modulus === 0 && zeroCount < 4) {
        outputCharacters += bigRadices[quotient];
      }
    }
    outputCharacters += CN_DOLLAR;
  }
  if (decimal !== '') {
    for (i = 0; i < decimal.length; i++) {
      d = decimal.substr(i, 1);
      if (d !== '0') {
        outputCharacters += digits[Number(d)] + decimals[i];
      }
    }
  }
  if (outputCharacters === '') {
    outputCharacters = CN_ZERO + CN_DOLLAR;
  }
  if (decimal === '') {
    outputCharacters += CN_INTEGER;
  }
  return outputCharacters || '';
};

/**
 * 手机号遮罩
 * @param {*} text
 * @returns
 */
Formatter.maskMobile = function (text) {
  text = '' + text;
  return text.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
};

/**
 * 身份证号遮罩
 * @param {String} id
 * @returns
 */
Formatter.maskIdCode = function (id) {
  id = '' + id;
  return id.replace(/^(\d{4})\d+(\d{3}[\dxX])$/, '$1****$2');
};
/**
 * 计算年龄-根据生日或身份证号
 * @param {String} str
 * @returns
 */
Formatter.computeAge = function (str) {
  if (str) {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(str)) {
      const birthDate = new Date(
        str.substring(6, 10),
        str.substring(10, 12) - 1,
        str.substring(12, 14)
      );
      const diff = new Date().getTime() - birthDate.getTime();
      const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
      return age;
    } else {
      const regBirthDate = /(\d{4})[./-]?(\d{1,2})[./-]?(\d{1,2})/;
      const match = str.match(regBirthDate);
      const year = parseInt(match[1]);
      const month = parseInt(match[2]) - 1;
      const day = parseInt(match[3]);
      const birthDate = new Date(year, month, day);
      const nowDate = new Date();
      let age = nowDate.getFullYear() - birthDate.getFullYear();
      const monthDiff = nowDate.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && nowDate.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }
  }
  return '';
};

/**
 * 筛除非数字元素
 * @param {String} value
 * @returns
 */
Formatter.filterNotNumber = function (value) {
  return value.replace(/[^0-9]/g, '');
};

/**
 * 筛除非身份证和手机号的输入元素
 * @param {String} value
 * @returns
 */
Formatter.filterTelId = function (value) {
  return value.replace(/[^0-9xX]/g, '').replace(/x/g, 'X');
};

/**
 * 筛除非身份证和手机号的输入元素
 * @param {String} value
 * @returns
 */
Formatter.filterInvalidChar = function (value) {
  return value.replace(/[^0-9a-zA-Z]/g, '');
};

/**
 * 筛除不安全的输入元素
 * @param {String} value
 * @returns
 */
Formatter.filterUnsafeChar = function (value) {
  return value.replace(/["'<>%;)(&+]/g, '');
};

/**
 * 身份证号遮罩 - 按需显示前后位数
 * @param {String} id
 * @param {number} pre 前保留数字个数
 * @param {number} post 后保留数字个数
 * @param {string} mask 替换用的字符
 * @returns
 */
Formatter.customMaskIdCode = function (id, pre = 3, post = 4, mask = Formatter.commonMaskChar) {
  id = '' + id;
  const idLength = id.length;
  let reminderPre = pre;
  let reminderPost = post;
  if (pre + post > idLength || !Number(pre) || !Number(post)) {
    reminderPre = 3;
    reminderPost = 4;
  }

  return id.replace(
    new RegExp(`(.{${reminderPre}}).*(.{${reminderPost}})`),
    `$1${mask.repeat(idLength - reminderPre - reminderPost)}$2`
  );
};

/**
 * 姓名遮罩: 仅显示最后一位
 * @param {String} name
 * @param {String} mask
 * @returns
 */
Formatter.maskRealName = function (name) {
  if (name) {
    return '**' + name.charAt(name.length - 1);
  }
  // if (name.length > 3) {
  //   name = name.substring(name.length - 3);
  // }
  // return name.replace(/.(?=.)/g, mask);
};

// 文字过长省略号
Formatter.ellipsis = function (value, length = 6) {
  value = '' + value;
  if (value.length > length) {
    value = value.slice(0, 6) + '...';
  }
  return value;
};

/**
 * 处理系统服务时间转换
 * @param {收银台计算费率所需要的参数整合成一个对象} obj
 * @returns {返回对象属性代码 beanTip rateTip}
 */
Formatter.convertTimeRange = function (timesReq) {
  let times = timesReq.split(',').map((el) => {
    return el.substring(0, 2) + ':' + el.substring(2, 4);
  });
  return times;
};
/**
 * 处理银行卡号格式化(xxxx xxxx xxxx xxx)
 * @param {String} number
 * @returns {String}
 */
Formatter.bankCardNumber = function (number) {
  if (!number) {
    return number;
  }
  const chunkSizes = [4, 4, 4, 4, 4];
  let i = 0,
    l = 0;
  let result = '';
  number = number.replace(/\D/g, ''); // 移除字符串中的非数字字符
  const len = Math.min(number.length, 23);
  while (i < len) {
    l = Math.min(len - i, chunkSizes.shift());
    result += number.substr(i, l) + ' ';
    i += l;
  }
  number = result.trim();
  return number;
};
/**
 * 处理手机号格式化(xxx xxxx xxxx)
 * @param {String} number
 * @returns {String}
 */
Formatter.mobileNumber = function (number) {
  if (!number) {
    return number;
  }
  number = number.replace(/\s+/g, '');
  switch (true) {
    case number.length > 3 && number.length < 8:
      number = number.replace(/^(\d{3})/g, '$1 ');
      break;
    case number.length >= 8 && number.length < 12:
      number = number.replace(/^(\d{3})(\d{4})/g, '$1 $2 ');
      break;
    default:
      break;
  }
  return number;
};
/**
 * 处理表单获取焦点，键盘弹出遮挡输入框
 * T: 'focus' || 'blur'
 */
Formatter.fieldEventScrollAct = function (T, Y) {
  if (UserAgent.isTiny() && UserAgent.isAndroid()) {
    const element = document.querySelector('.ph_layout_page_bd');
    if (element) {
      element.style.transform = T == 'focus' ? `translateY(${Y || '-35'}%)` : 'translateY(0%)';
      element.style.transition = 'all 0.3s';
    }
  }
};

export default Formatter;



// WEBPACK FOOTER //
// ./src/utils/formatter.js